import signedFetch from '../../../apiCalls/util/signedFetch.js';

export default function* generateReportApi(reportType) {
  return yield signedFetch('generateReport', `${__API_BASE__}/report/${reportType}`, 'POST');
}
